import { EyeIcon } from "lucide-react";

import { Button } from "@/components/button";
import { useImpersonate } from "@/hooks/useImpersonate";

export function ImpersonateUser({ id }: { id: string }) {
  const impersonateMutation = useImpersonate();

  return (
    <Button
      isDisabled={impersonateMutation.isPending}
      onPress={() =>
        impersonateMutation.mutate({
          targetUserId: Number(id),
        })
      }
      size="sm"
      variant="secondary"
    >
      <EyeIcon />
      Impersonate
    </Button>
  );
}
